document.addEventListener("DOMContentLoaded", function () {
  const main = document.querySelector("main");
  const header = document.querySelector(".header");
  const headerHeight = header.offsetHeight;

  function adjustPadding() {
    if (window.scrollY === 0) {
      main.style.paddingTop = headerHeight + "px";
    } else {
      main.style.paddingTop = "0px";
    }
  }

  adjustPadding();
  window.addEventListener("scroll", adjustPadding);
});
